import type { State } from 'model/State';

export const selectOrderableItemByAccountId = (state: State, accountId: number) =>
  state.mac.product.orderableItemByAccountId?.[accountId]?.ifSuccess((r) => r);
